<template>
  <div class="table-form table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th>Rezervasyon No</th>
          <th>İletişim Kişisi</th>
          <th>Yolcu Sayısı</th>
          <th>Oda Sayısı</th>
          <th>Fiyat</th>
          <th>Durum</th>
          <th> &nbsp; </th>
          <th>Rezervasyon Tarihi</th>
          <th>-</th>
        </tr>
      </thead>
      <tbody>
      <tr v-for="booking in bookingList" :key="booking.id">
        <th><a :href="basePath+'/bookings/'+booking.id">#{{booking.id}}</a></th>
        <th>{{ booking.bookingNumber }}</th>
        <th>{{ booking.contactName }}</th>
        <th>{{ booking.passengerCount }}</th>
        <th>{{ booking.bookingRooms.length }}</th>
        <th>{{ booking.totalPrice | toCurrency }} </th>
        <th>
          <reservation-status :booking-status="booking.bookingStatus"></reservation-status>
        </th>
        <th>
          <span v-if="booking.paymentCheck && booking.paymentCheck.needRefund" class="badge badge-warning py-1 px-2">İade Gerekiyor</span>
        </th>
        <th>{{ booking.createDate | ddMMyyyyHHmm }}</th>
        <td>
          <div class="table-content">
            <a :href="basePath+'/bookings/'+booking.id" class="theme-btn theme-btn-small" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit">
              <i class="la la-edit"></i>
            </a>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import ReservationStatus from "../common/ReservationStatus";
export default {
  name: "AgencyBookingList",
  components: {ReservationStatus},
  props : {
    bookingList: null,
  },
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    }
  },
}
</script>

<style scoped>

.table-form thead th {
  background-color: white;
  color: #1976d2;
}

.theme-btn{
  color: white!important;
}
</style>